import React from 'react';
import {observer} from 'mobx-react';
import {Panel, Input, FormLayout, FormError, Select2, CheckboxWithLabel, LabelHelper} from 'shared/components';
import {t} from 'shared/core';
import {FormattedMessage} from 'react-intl';

const RelativeDateSelector = observer(({label, value, unit, onValueChange, onUnitChange, errorMessage}) => {
  return (
    <div>
      <LabelHelper translateLabel label={label}/>
      <div className='flex align-items-middle space-x'>
        <Input
          value={value}
          onChange={e => onValueChange(e.target.value)}
        />
        <Select2
          value={unit}
          onChange={e => onUnitChange(e.target.value)}
        >
          <option key='days' value='days'>{t('days')}</option>
          <option key='weeks' value='weeks'>{t('weeks')}</option>
        </Select2>
        <FormattedMessage id='performance_reviews.edit.after employee start date'/>
      </div>
      <FormError message={errorMessage}/>
    </div>
  );
});

const Overview = observer(({uiState}) => {
  const {cycle, errors} = uiState;

  return (
    <div>
      <Panel.Header title={t('performance_reviews.edit.Overview')}/>
      <FormLayout>
        <Input
          placeholder='performance_reviews.edit.e.g., Q4 2025 Review'
          errorMessage={errors.name}
          value={cycle.name}
          label='performance_reviews.edit.Review name'
          onChange={e => cycle.merge({name: e.target.value})}
          className='large'
        />
        <div>
          <CheckboxWithLabel
            label='performance_reviews.edit.Make review cycle applicable to new hires'
            checked={cycle.availableInHiring}
            onChange={(e) => uiState.toggleAvailableInHiring(e.checked)}
          />
          {cycle.availableInHiring && <div className='jumbo'>
            <FormattedMessage id="performance_reviews.edit.Choose how long after an employee's start date they should be assigned the review, and when it should be due."/>
          </div>}
        </div>
        {cycle.availableInHiring && <RelativeDateSelector
          label={'performance_reviews.edit.Launch Date'}
          value={cycle.relativeLaunchDateValue}
          unit={cycle.relativeLaunchDateUnit}
          onValueChange={(value) => cycle.relativeLaunchDateValue = value}
          onUnitChange={(value) => cycle.relativeLaunchDateUnit = value}
          errorMessage={errors.relativeLaunchDateValue}
        />}
        {cycle.availableInHiring && <RelativeDateSelector
          label={'performance_reviews.edit.Due Date'}
          value={cycle.relativeDueDateValue}
          unit={cycle.relativeDueDateUnit}
          onValueChange={(value) => cycle.relativeDueDateValue = value}
          onUnitChange={(value) => cycle.relativeDueDateUnit = value}
          errorMessage={errors.relativeDueDateValue}
        />}
      </FormLayout>
    </div>
  );
});

export default Overview;
